(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arventra-espresso-pdp-v4"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.__aideferPDPV8) { window.__aideferPDPV8.boot(); return; }
  const cleanText = (value) => String(value ?? '').replace(/\u00a0/g, ' ').replace(/\r/g, '').trim();

  const readBlocks = (source) => {
    const blocks = [];
    let buffer = '';
    const flush = () => {
      const text = cleanText(buffer);
      if (text) blocks.push({ type: 'text', text });
      buffer = '';
    };
    const visit = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = (node.textContent || '').split(/\n/);
        parts.forEach((part, i) => { if (i) flush(); buffer += part; });
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      const tag = node.tagName.toLowerCase();
      if (['script', 'style', 'template'].includes(tag)) return;
      if (tag === 'br') { flush(); return; }
      if (/^h[1-6]$/.test(tag)) {
        flush();
        const text = cleanText(node.textContent);
        if (text) blocks.push({ type: 'heading', text });
        return;
      }
      const block = ['div', 'p', 'li', 'ul', 'ol', 'section', 'blockquote'].includes(tag);
      if (block) flush();
      node.childNodes.forEach(visit);
      if (block) flush();
    };
    source.childNodes.forEach(visit);
    flush();
    return blocks;
  };

  const hasComplexMarkup = (source) => Boolean(source.querySelector('table, a, img, video, iframe, details, dl'));
  const stripBullet = (text) => cleanText(text).replace(/^(?:[•▪◦✓]|[-–—]\s)\s*/, '');

  const splitLabelValue = (line) => {
    const text = stripBullet(line);
    const colon = text.indexOf(':');
    if (colon > 0 && colon < 100 && !/https?:\/\//i.test(text.slice(0, colon + 3))) {
      const label = cleanText(text.slice(0, colon));
      const value = cleanText(text.slice(colon + 1));
      if (value) return { label, value };
    }
    const dash = text.match(/^(.{1,80}?)\s+[–—-]\s+(.+)$/);
    if (dash) return { label: cleanText(dash[1]), value: cleanText(dash[2]) };
    return null;
  };

  const renderKeyFeatures = (section) => {
    const source = section.querySelector('[data-key-features-fallback]');
    if (!source || source.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading' && !/^key features:?$/i.test(block.text))) return;
    const items = blocks.filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const makeList = (rows) => {
      const list = document.createElement('ul');
      rows.forEach((item) => {
        const li = document.createElement('li');
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';
        li.append(icon, document.createTextNode(item));
        list.append(li);
      });
      return list;
    };
    source.replaceChildren(makeList(items));
    source.dataset.enhanced = 'true';
  };

  const renderSpecifications = (section) => {
    const source = section.querySelector('[data-specs-fallback]');
    const target = section.querySelector('[data-specs-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (!blocks.length) return;
    const groups = [];
    let group = { title: 'Product Specifications', entries: [] };
    let parsedRows = 0;
    let ambiguousHeading = false;
    const pushGroup = () => { if (group.entries.length) groups.push(group); };
    blocks.forEach((block) => {
      const text = stripBullet(block.text);
      const explicitHeading = block.type === 'heading' || /^\[.+\]$/.test(text) || /^[^:]{1,80}:$/.test(text);
      if (explicitHeading) {
        if (group.entries.length) pushGroup();
        else if (!/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
        group = { title: text.replace(/^\[|\]$/g, '').replace(/:$/, ''), entries: [] };
        return;
      }
      const row = splitLabelValue(text);
      if (row) { group.entries.push(row); parsedRows += 1; }
      else if (text) group.entries.push({ text });
    });
    if (!group.entries.length && !/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
    pushGroup();
    if (ambiguousHeading || !parsedRows || !groups.length || groups.some((item) => item.entries.some((entry) => 'text' in entry))) return;
    const fragment = document.createDocumentFragment();
    groups.forEach((item, index) => {
      const details = document.createElement('details');
      details.className = 'aidefer-pdp__spec-group';
      details.open = index === 0;
      const summary = document.createElement('summary');
      summary.textContent = item.title;
      const rows = document.createElement('dl');
      rows.className = 'aidefer-pdp__spec-rows';
      item.entries.forEach((entry) => {
        if ('text' in entry) {
          const p = document.createElement('p');
          p.className = 'aidefer-pdp__spec-note';
          p.textContent = entry.text;
          rows.append(p);
        } else {
          const row = document.createElement('div');
          row.className = 'aidefer-pdp__spec-row';
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = entry.label;
          value.textContent = entry.value;
          row.append(label, value);
          rows.append(row);
        }
      });
      details.append(summary, rows);
      fragment.append(details);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const renderIncluded = (section) => {
    const source = section.querySelector('[data-included-fallback]');
    const target = section.querySelector('[data-included-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading')) return;
    const items = blocks.map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const fragment = document.createDocumentFragment();
    items.forEach((text) => {
      const card = document.createElement('article');
      card.className = 'aidefer-pdp__included-card';
      const icon = document.createElement('div');
      icon.className = 'aidefer-pdp__included-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '◇';
      const title = document.createElement('strong');
      title.textContent = text;
      card.append(icon, title);
      fragment.append(card);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const initProductContent = (section) => {
    [renderKeyFeatures, renderSpecifications, renderIncluded].forEach((enhance) => {
      try { enhance(section); }
      catch (error) { console.warn('Aidefer: original product content retained.', error); }
    });
  };

  const attachFeatureDisclosure = (section, listen, signal) => {
    const wrap = section.querySelector('[data-key-features-wrap]');
    const source = wrap?.querySelector('[data-key-features-fallback]');
    const button = wrap?.querySelector('[data-features-toggle]');
    if (!wrap || !source || !button || wrap.dataset.collapseFeatures === 'false') return () => {};
    const rows = readBlocks(source).filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!rows.length) return () => {};
    const preview = document.createElement('div');
    preview.className = 'aidefer-pdp__features-preview';
    preview.hidden = true;
    const list = document.createElement('ul');
    rows.slice(0, 3).forEach((row) => {
      const li = document.createElement('li');
      const check = document.createElement('span');
      check.textContent = '✓';
      check.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'aidefer-pdp__feature-preview-text';
      text.textContent = row;
      li.append(check, text);
      list.append(li);
    });
    preview.append(list);
    source.before(preview);
    let expanded = false;
    let needed = false;
    let frame = 0;
    let lastWidth = 0;
    const measure = () => {
      const wasHidden = source.hidden;
      const oldStyle = source.getAttribute('style');
      if (wasHidden) {
        source.style.position = 'absolute';
        source.style.visibility = 'hidden';
        source.style.width = `${wrap.clientWidth}px`;
        source.hidden = false;
      }
      const height = source.scrollHeight;
      if (wasHidden) {
        source.hidden = true;
        if (oldStyle === null) source.removeAttribute('style'); else source.setAttribute('style', oldStyle);
      }
      return height;
    };
    const apply = () => {
      source.hidden = needed && !expanded;
      preview.hidden = !needed || expanded;
      button.hidden = !needed;
      button.setAttribute('aria-expanded', String(expanded || !needed));
      button.textContent = expanded ? button.dataset.lessLabel || 'Show less' : button.dataset.moreLabel || 'Show more';
    };
    const refresh = () => {
      frame = 0;
      if (signal.aborted || !wrap.isConnected) return;
      const limit = parseFloat(getComputedStyle(wrap).getPropertyValue('--ap-features-preview')) || 84;
      needed = rows.length > 3 || measure() > limit + 2;
      if (!needed) expanded = false;
      apply();
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
    listen(button, 'click', () => {
      expanded = !expanded;
      apply();
      if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
    const observer = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width || 0;
      if (Math.abs(width - lastWidth) > 1) { lastWidth = width; schedule(); }
    }) : null;
    observer?.observe(wrap);
    listen(window, 'resize', schedule, { passive: true });
    document.fonts?.ready.then(() => { if (!signal.aborted) schedule(); });
    refresh();
    return () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      preview.remove();
      source.hidden = false;
      button.hidden = true;
    };
  };

  const attachOverviewDisclosure = (section, listen, signal) => {
    const wrap = section.querySelector('[data-overview-copy]');
    const content = wrap?.querySelector('[data-overview-content]');
    const button = wrap?.querySelector('[data-overview-toggle]');
    if (!wrap || !content || !button || wrap.dataset.compactOverview === 'false') return () => {};

    let expanded = false;
    let needed = true;
    let frame = 0;
    let observer = null;

    const apply = () => {
      wrap.classList.toggle('is-collapsed', needed && !expanded);
      button.hidden = !needed;
      button.setAttribute('aria-expanded', String(expanded || !needed));
      button.textContent = expanded
        ? button.dataset.lessLabel || 'Show less'
        : button.dataset.moreLabel || 'Read full description';
    };

    const measure = () => {
      frame = 0;
      if (signal.aborted || !wrap.isConnected) return;

      const limit = parseFloat(getComputedStyle(wrap).getPropertyValue('--ap-overview-preview')) || 340;
      const wasCollapsed = wrap.classList.contains('is-collapsed');
      wrap.classList.remove('is-collapsed');
      const fullHeight = content.scrollHeight;
      if (wasCollapsed && !expanded) wrap.classList.add('is-collapsed');

      needed = fullHeight > limit + 24;
      if (!needed) expanded = false;
      apply();
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };

    listen(button, 'click', () => {
      expanded = !expanded;
      apply();
      if (!expanded) {
        wrap.scrollIntoView({
          block: 'nearest',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(content);
    } else {
      listen(window, 'resize', schedule, { passive: true });
    }

    document.fonts?.ready.then(() => {
      if (!signal.aborted) schedule();
    });

    measure();

    return () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      wrap.classList.remove('is-collapsed');
      button.hidden = true;
    };
  };

  const attachInteractions = (section) => {
    const controller = new AbortController();
    const { signal } = controller;
    const listen = (target, name, callback, options = {}) => target?.addEventListener(name, callback, { ...options, signal });
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const panels = [...section.querySelectorAll('[data-media-item]')];
    const panelMap = new Map(panels.map((panel) => [panel.dataset.mediaItem, panel]));
    const status = section.querySelector('[data-gallery-status]');
    let activeId = panels.find((panel) => !panel.hidden)?.dataset.mediaItem;
    let lastZoomTrigger = null;
    let raf = 0;
    const dialog = section.querySelector('[data-zoom-dialog]');
    const zoomContent = section.querySelector('[data-zoom-content]');
    const select = section.querySelector('[data-variant-select]');
    const input = section.querySelector('[data-quantity-input]');
    const minus = section.querySelector('[data-quantity-minus]');
    const plus = section.querySelector('[data-quantity-plus]');
    const add = section.querySelector('[data-add-to-cart]');
    const sticky = section.querySelector('[data-mobile-sticky]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const cleanupFeatures = attachFeatureDisclosure(section, listen, signal);
    const cleanupOverview = attachOverviewDisclosure(section, listen, signal);
    const picker = section.querySelector('[data-option-picker]');
    const nativeVariantField = section.querySelector('[data-native-variant-field]');
    const optionGroups = [...(picker?.querySelectorAll('[data-option-position]') || [])];
    const optionInputs = [...(picker?.querySelectorAll('[data-option-input]') || [])];
    const optionMessage = picker?.querySelector('[data-option-message]');
    let remoteRequest = null;
    let requestNumber = 0;

    const mountMedia = (panel) => {
      const template = panel.querySelector('template[data-deferred-media]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      panel.querySelectorAll('iframe[data-aidefer-src]').forEach((frame) => {
        frame.src = frame.dataset.aideferSrc;
        delete frame.dataset.aideferSrc;
      });
    };
    const pauseMedia = (panel) => {
      panel.querySelectorAll('video').forEach((video) => video.pause());
      panel.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
      panel.querySelectorAll('iframe').forEach((frame) => {
        if (frame.hasAttribute('src') && frame.getAttribute('src') !== 'about:blank') {
          frame.dataset.aideferSrc = frame.getAttribute('src');
          frame.src = 'about:blank';
        }
      });
    };
    const showMedia = (id, announce = true) => {
      const key = String(id || '');
      const next = panelMap.get(key);
      if (!next) return false;
      panels.forEach((panel) => {
        const active = panel === next;
        if (!active && !panel.hidden) pauseMedia(panel);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      mountMedia(next);
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaTarget === key;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      activeId = key;
      if (announce && status) status.textContent = `Media ${panels.indexOf(next) + 1} of ${panels.length}`;
      return true;
    };
    listen(section.querySelector('[data-gallery]'), 'click', (event) => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) showMedia(thumb.dataset.mediaTarget);
      const trigger = event.target.closest('[data-zoom-open]');
      if (!trigger || !dialog?.showModal || !zoomContent) return;
      event.preventDefault();
      lastZoomTrigger = trigger;
      const image = new Image();
      image.alt = trigger.querySelector('img')?.alt || '';
      image.decoding = 'async';
      image.src = trigger.href;
      zoomContent.replaceChildren(image);
      dialog.showModal();
      dialog.querySelector('[data-zoom-close]')?.focus();
      scheduleSticky();
    });
    listen(section.querySelector('.aidefer-pdp__thumbs'), 'keydown', (event) => {
      const current = thumbs.indexOf(event.target.closest('[data-media-target]'));
      if (current < 0) return;
      let next;
      if (['ArrowRight','ArrowDown'].includes(event.key)) next = (current + 1) % thumbs.length;
      else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (current - 1 + thumbs.length) % thumbs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = thumbs.length - 1;
      else return;
      event.preventDefault();
      thumbs[next].focus({ preventScroll: true });
      thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      showMedia(thumbs[next].dataset.mediaTarget);
    });
    listen(section.querySelector('[data-zoom-close]'), 'click', () => dialog?.close());
    listen(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
    listen(dialog, 'close', () => {
      zoomContent?.replaceChildren();
      if (lastZoomTrigger?.isConnected) lastZoomTrigger.focus({ preventScroll: true });
      scheduleSticky();
    });

    const rules = () => ({
      min: Math.max(1, Number(input?.min) || 1),
      step: Math.max(1, Number(input?.step) || 1),
      max: input?.hasAttribute('max') ? Number(input.max) : Infinity
    });
    const updateQuantityButtons = () => {
      if (!input) return;
      const { min, max, step } = rules();
      const value = Number(input.value);
      if (minus) minus.disabled = !Number.isFinite(value) || value <= min;
      if (plus) plus.disabled = !Number.isFinite(value) || value + step > max;
    };
    const normalizeQuantity = () => {
      if (!input) return;
      const { min, max, step } = rules();
      let value = Number(input.value);
      if (!Number.isFinite(value) || input.value.trim() === '') value = min;
      value = Math.max(min, value);
      value = min + Math.round((value - min) / step) * step;
      if (Number.isFinite(max)) value = Math.min(value, min + Math.floor((max - min) / step) * step);
      input.value = String(Math.max(min, value));
      updateQuantityButtons();
    };
    const changeQuantity = (direction) => {
      if (!input) return;
      normalizeQuantity();
      input.value = String(Number(input.value) + direction * rules().step);
      normalizeQuantity();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    listen(minus, 'click', () => changeQuantity(-1));
    listen(plus, 'click', () => changeQuantity(1));
    listen(input, 'input', updateQuantityButtons);
    listen(input, 'change', normalizeQuantity);

    const records = () => [...(select?.options || [])].filter((option) => option.value).map((option) => ({ option, values: optionGroups.map((group) => option.dataset[`option${group.dataset.optionPosition}`] || '') }));
    const selection = () => optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
    const sameValues = (a, b) => a.length === b.length && a.every((value, index) => value === b[index]);
    const allVariantsLoaded = () => Number(select?.dataset.variantCount || 0) <= records().length;
    const setText = (selector, value) => { const node = section.querySelector(selector); if (node) node.textContent = value; };
    const setMessage = (message) => {
      if (optionMessage) { optionMessage.textContent = message; optionMessage.hidden = !message; }
    };
    const syncOptionLabels = () => optionGroups.forEach((group) => {
      const selected = group.querySelector('[data-option-input]:checked');
      const label = group.querySelector('[data-option-current]');
      if (label) label.textContent = selected?.value || '';
    });
    const setURL = (variantId) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('option_values');
      if (variantId) url.searchParams.set('variant', variantId);
      else {
        url.searchParams.delete('variant');
        const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
        if (ids.length && ids.every(Boolean)) url.searchParams.set('option_values', ids.join(','));
      }
      window.history.replaceState(window.history.state, '', url);
    };
    const paintAvailability = () => {
      syncOptionLabels();
      if (!allVariantsLoaded()) return;
      const values = selection();
      const availableRecords = records();
      optionGroups.forEach((group, index) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        const desired = [...values];
        desired[index] = radio.value;
        const match = availableRecords.find((record) => sameValues(record.values, desired));
        const state = !match ? 'missing' : match.option.dataset.available === 'true' ? 'available' : 'soldout';
        const choice = radio.closest('[data-option-choice]');
        if (choice) {
          choice.dataset.optionState = state;
          choice.title = state === 'available' ? radio.value : `${radio.value} — ${state === 'soldout' ? 'Sold out' : 'Not offered with the other selected options'}`;
        }
        radio.setAttribute('aria-label', choice?.title || radio.value);
      }));
    };
    const blockPurchase = (message, loading = false) => {
      if (select) { select.selectedIndex = -1; select.disabled = true; }
      if (add) add.disabled = true;
      setText('[data-add-label]', loading ? 'Checking options…' : 'Unavailable');
      if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = loading ? 'Checking…' : 'Unavailable'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = true;
      const terms = section.querySelector('.aidefer-pdp__payment-terms');
      if (terms) terms.hidden = true;
      setText('[data-current-price]', '—');
      setText('[data-sticky-price]', '—');
      for (const selector of ['[data-compare-price]', '[data-saving]', '[data-sku-wrap]']) {
        const node = section.querySelector(selector); if (node) node.hidden = true;
      }
      setText('[data-stock-status]', loading ? 'Checking availability' : 'Unavailable combination');
      section.querySelector('[data-stock-status]')?.classList.add('is-sold-out');
      setMessage(message);
      setText('[data-variant-status]', message);
      scheduleSticky();
    };
    const updateVariant = (announce = false) => {
      const option = select?.selectedOptions[0];
      if (!option || !option.value) {
        normalizeQuantity();
        if (picker && !picker.hidden) blockPurchase('This combination is not offered. Choose another option.');
        return;
      }
      select.disabled = false;
      const data = option.dataset;
      const available = data.available === 'true';
      setText('[data-current-price]', data.price || '');
      setText('[data-sticky-price]', data.price || '');
      setText('[data-compare-price]', data.compare || '');
      setText('[data-saving]', data.saving || '');
      const compare = section.querySelector('[data-compare-price]');
      const saving = section.querySelector('[data-saving]');
      if (compare) compare.hidden = !data.compare;
      if (saving) saving.hidden = !data.saving;
      const skuWrap = section.querySelector('[data-sku-wrap]');
      if (skuWrap) skuWrap.hidden = !data.sku;
      setText('[data-product-sku]', data.sku ? `SKU: ${data.sku}` : '');
      const stock = section.querySelector('[data-stock-status]');
      if (stock) {
        stock.textContent = data.stockText || (available ? 'Available' : 'Sold Out');
        stock.classList.toggle('is-sold-out', !available);
      }
      if (add) add.disabled = !available;
      setText('[data-add-label]', available ? 'Add to Cart' : 'Sold Out');
      if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = available ? 'Add to Cart' : 'Sold Out'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = !available;
      const terms = section.querySelector('.aidefer-pdp__payment-terms');
      if (terms) terms.hidden = false;
      if (input) {
        input.min = data.min || '1';
        input.step = data.step || '1';
        if (data.max) input.max = data.max;
        else input.removeAttribute('max');
        normalizeQuantity();
      }
      optionGroups.forEach((group) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        radio.checked = radio.value === data[`option${group.dataset.optionPosition}`];
      }));
      paintAvailability();
      setMessage(available ? '' : 'This configuration is sold out. Select another color or version.');
      if (data.mediaId) showMedia(data.mediaId, false);
      if (announce) {
        setURL(option.value);
        setText('[data-variant-status]', `${option.textContent.trim()}. ${data.price || ''}. ${stock?.textContent || ''}`);
        section.dispatchEvent(new CustomEvent('aidefer:variant-change', { bubbles: true, detail: { variantId: option.value, available } }));
      }
      scheduleSticky();
    };
    const resolveRemote = async (values) => {
      const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
      if (!ids.length || ids.some((id) => !id)) { blockPurchase('Unable to check this combination. Please refresh the page.'); return; }
      remoteRequest?.abort();
      const request = new AbortController();
      remoteRequest = request;
      const sequence = ++requestNumber;
      const timeout = setTimeout(() => request.abort(), 12000);
      blockPurchase('Checking the selected options…', true);
      setURL('');
      const url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', section.dataset.sectionId);
      url.searchParams.set('option_values', ids.join(','));
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin', signal: request.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Variant lookup failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== requestNumber || signal.aborted || !sameValues(values, selection())) return;
        const incoming = [...doc.querySelectorAll('[data-aidefer-pdp]')].find((node) => node.dataset.productId === section.dataset.productId && node.dataset.sectionId === section.dataset.sectionId);
        if (!incoming) throw new Error('Product section missing');
        incoming.querySelectorAll('[data-option-input]').forEach((next) => {
          const radio = optionInputs.find((old) => old.dataset.optionId === next.dataset.optionId);
          if (!radio) return;
          const nextChoice = next.closest('[data-option-choice]');
          if (nextChoice?.dataset.optionState) radio.closest('[data-option-choice]').dataset.optionState = nextChoice.dataset.optionState;
        });
        const incomingOption = incoming.querySelector('[data-variant-select] option[selected]');
        const incomingValues = optionGroups.map((group) => incomingOption?.dataset[`option${group.dataset.optionPosition}`] || '');
        if (!incomingOption?.value || !sameValues(incomingValues, values)) { blockPurchase('This combination is not offered. Choose another option.'); return; }
        [...select.options].filter((option) => option.value === incomingOption.value).forEach((option) => option.remove());
        const option = document.importNode(incomingOption, true);
        select.append(option);
        select.disabled = false;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {
        if (sequence === requestNumber && !signal.aborted) blockPurchase('We could not check these options. Select a different option to retry, or refresh the page.');
      } finally { clearTimeout(timeout); }
    };
    const chooseOptions = (radio) => {
      const targetURL = radio.dataset.productUrl;
      if (targetURL) {
        const target = new URL(targetURL, window.location.origin);
        const current = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
        if (target.origin === window.location.origin && target.pathname !== current.pathname) { window.location.assign(target.href); return; }
      }
      const values = selection();
      paintAvailability();
      if (!allVariantsLoaded()) { resolveRemote(values); return; }
      remoteRequest?.abort();
      requestNumber += 1;
      const match = records().find((record) => sameValues(record.values, values));
      if (!match) { blockPurchase('This combination is not offered. Choose another option.'); setURL(''); return; }
      select.disabled = false;
      select.value = match.option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (picker && select && optionGroups.length && optionGroups.every((group) => group.querySelector('[data-option-input]'))) {
      picker.hidden = false;
      nativeVariantField.hidden = true;
      listen(picker, 'change', (event) => { if (event.target.matches('[data-option-input]')) chooseOptions(event.target); });
  
    }
    listen(select, 'change', () => updateVariant(true));
    listen(window, 'pageshow', () => { if (!select?.disabled) updateVariant(false); });
    listen(select?.form, 'submit', (event) => {
      if (picker && !picker.hidden && (!select.value || select.disabled || add?.disabled)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setMessage('Please select an available product configuration before adding to cart.');
      }
    }, { capture: true });

    const refreshSticky = () => {
      raf = 0;
      if (!sticky || !add) return;
      const editing = document.activeElement?.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]');
      const shouldShow = mobile.matches && !editing && !dialog?.open && add.getBoundingClientRect().bottom <= 0 && section.getBoundingClientRect().bottom > window.innerHeight;
      sticky.hidden = !shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
    };
    function scheduleSticky() { if (sticky && !raf) raf = requestAnimationFrame(refreshSticky); }
    listen(stickyAdd, 'click', () => {
      normalizeQuantity();
      if (input && !input.checkValidity()) {
        input.scrollIntoView({ block: 'center' });
        input.reportValidity();
        return;
      }
      if (add && !add.disabled) add.click();
    });
    if (sticky) {
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky, { passive: true });
      listen(window.visualViewport, 'resize', scheduleSticky, { passive: true });
      listen(document, 'focusin', scheduleSticky);
      listen(document, 'focusout', scheduleSticky);
    }
    if (activeId) showMedia(activeId, false);
    updateVariant(false);
    normalizeQuantity();
    scheduleSticky();
    return () => {
      controller.abort();
      requestNumber += 1;
      remoteRequest?.abort();
      cleanupFeatures();
      cleanupOverview();
      if (nativeVariantField) nativeVariantField.hidden = false;
      if (picker) picker.hidden = true;
      if (raf) cancelAnimationFrame(raf);
      panels.forEach(pauseMedia);
      if (dialog?.open) dialog.close();
      zoomContent?.replaceChildren();
      delete section.dataset.aideferInitialized;
    };
  };

  const instances = new Map();
  const init = (section) => {
    if (!section || instances.has(section) || section.dataset.aideferBuild !== '8') return;
    initProductContent(section);
    const cleanup = attachInteractions(section);
    instances.set(section, cleanup);
    section.dataset.aideferInitialized = '8';
  };
  const collect = (root = document) => {
    if (root.matches?.('[data-aidefer-pdp]')) init(root);
    root.querySelectorAll?.('[data-aidefer-pdp]').forEach(init);
  };
  const lifecycle = { boot: collect };
  window.__aideferPDPV8 = lifecycle;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  else collect();
  document.addEventListener('shopify:section:load', (event) => collect(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, cleanup] of instances) {
      if (section === event.target || event.target.contains(section)) { cleanup(); instances.delete(section); }
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
